





















import Vue from 'vue';
import {Skill} from '@/models';

export default Vue.extend({
  name: 'SkillIcon',
  props: [
    'skill',
    'isActive',
    'size',
  ],
  data() {
    return {
      hover: false,
    };
  },
  watch: {
    isActive(newVal, _) {
      if (!newVal) {
        this.hover = false;
      }
    },
  },
});
